import util from '@bmp-vue/core/api/util'
const controller = 'Trademaster'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
